<template>
    <div class="video-container mb-20">
      <video controls disablepictureinpicture controlsList="nodownload">
        <source :src="video.name">
      </video>
      <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'"
                 :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
      <button
        type="submit"
        class="btn btn-primary waves-effect waves-classic btn-save"
        @click.prevent="downloadCheckListVideo(video)"
        :disabled="smallLoading"
      >
        {{$t("button.download")}}
      </button>
    </div>
</template>

<script>
    import checkListGroupService from "../../../services/checklist_group";

    export default {
        name: "ChecklistVideo",
        data() {
          return {
            smallLoading: false
          }
        },
        props: [
          'video'
        ],
        components: {
          VLoading : require('components/loading/loading.vue'),
        },
        methods: {
          async downloadCheckListVideo() {
            this.smallLoading = true;
            await checkListGroupService.downloadMultimedia(this, this.video);
          }
        }
    }
</script>

<style scoped>
  .video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .video-container button {
    margin-top: 10px;
  }

  .video-container video {
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// ChecklistVideo.vue?0ae66ff2